// client/src/components/backButton.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './backButton.css';
import '../../styles/globalstyles.css';

const BackButton = ({ to, activeTab, label = '← Back' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Navigate back to previous page with the specified active tab
    navigate(to, { state: { activeTab } });
  };

  return (
    // <button className="custom-back-button" onClick={handleBack}>
    <button 
      className="custom-back-button" 
      onClick={handleBack}
    >
      {label}
    </button>
  );
};

export default BackButton;